import React from "react";
import "./index.scss";

const Confession = () => (
  <section className="PgEM-C">
    <div className="PgEM-C__content">
      <div className="PgEM-C__decor" />
      <div className="PgEM-C-info">
        <p className="PgEM-C__interest">75%</p>
        <p className="PgEM-C__text">
          de vendedores en Amazon admiten haberse{" "}
          <b>arrepentido de no usar herramientas de investigación</b> al iniciar
          sus negocios y buscar sus primeras ideas rentables
        </p>
      </div>
    </div>
  </section>
);
export default Confession;
